// extracted by mini-css-extract-plugin
module.exports = {"footerButton":"_3iBT5","countryBox":"_1NmDD","outBox":"_2OEQX"};